import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, BriefcaseIcon, DollarSignIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="bg-navy text-white py-16 px-6" data-id="element-147">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto" data-id="element-148">
        <h2 className="font-serif text-3xl md:text-4xl mb-8 text-center" data-id="element-149">
          El Sistema Está Diseñado Para Que{' '}
          <span className="text-gold" data-id="element-150">La Empresa Gane</span>
        </h2>

        <div className="space-y-6" data-id="element-151">
          <div className="flex items-start gap-4" data-id="element-152">
            <AlertTriangleIcon className="w-8 h-8 text-gold flex-shrink-0 mt-1" data-id="element-153" />
            <p className="text-lg" data-id="element-154">
              RRHH tiene manuales para <strong data-id="element-155">minimizar tu liquidación</strong>
              . Los abogados son caros y las guías de internet son demasiado
              genéricas para nuestra realidad en Latinoamérica y España.
            </p>
          </div>

          <div className="flex items-start gap-4" data-id="element-156">
            <DollarSignIcon className="w-8 h-8 text-gold flex-shrink-0 mt-1" data-id="element-157" />
            <p className="text-lg" data-id="element-158">
              Si te vas sin estrategia, te quedas solo con{' '}
              <strong data-id="element-159">tus ahorros disminuyendo cada día</strong> mientras el
              mercado laboral parece una selva imposible de descifrar.
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}